import { XMarkIcon } from '@heroicons/react/24/outline'
import Image from 'next/image'
import { FC } from 'react'

import Modal from '@/components/Modal'
import { IShareItem } from '.'
import styles from './ShareboxDialog.module.scss'

interface IShareboxDialogProps {
  isOpen: boolean
  onClose: () => void
  shareList: IShareItem[]
}

const ShareboxDialog: FC<IShareboxDialogProps> = ({ isOpen, onClose, shareList }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={`rounded-lg bg-white px-4 py-6 ${styles.ShareboxDialogWrapper}`}>
        <header className="flex justify-between">
          <h3 className="text-center text-xl font-bold">공유하기</h3>
          <button className="flex h-5 w-5 items-center justify-center" onClick={onClose}>
            <XMarkIcon className="h-auto w-5"></XMarkIcon>
          </button>
        </header>
        <main className="mb-2 mt-6">
          <dl className="flex w-full gap-5">
            {shareList.map(({ imgSrc, title, onShareHandler, id }) => {
              return (
                <div
                  id={id}
                  key={title}
                  className="flex cursor-pointer flex-col"
                  onClick={onShareHandler}>
                  <dt className="relative flex items-center justify-center">
                    <Image src={imgSrc} width={50} height={50} alt={`${title} 아이콘`} />
                  </dt>
                  <dd className="mt-2 flex items-center justify-center">
                    <span className="font-normal">{title}</span>
                  </dd>
                </div>
              )
            })}
          </dl>
        </main>
      </div>
    </Modal>
  )
}

export default ShareboxDialog
